<!--
 * @FileDescription: 库存状况的弹框（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div>
        <a-modal class="material-model1" v-model="isShowModel" :okText="okText"  @ok="onCofrimForm"  @cancel="onCancel">
            <p class="model-p model-p1">如果您在最初使用软件时，没有录入正确的库存数量或是正确的 库存成本。</p>
            <p class="model-p">现在可以 用本单据把当前库存数量或是库存成本修改正确，修改 后所产生的当前库存数量与本单据修改前库存数量的差额，将被计入 到期初库存。</p>
        </a-modal>
        <a-modal v-model="isShowModel1" :title="title"  class="material-model2"  @cancel="onCancel" :okText="okText1" :cancelText="cancelText" @ok="onCofrimForm1">
            <a-form :form="form"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                    class="display-flex material-form"
            >
                <div class="form-left">
                    <a-form-item label="单据单号">
                        <a-input placeholder="请输入单据单号"
                                 class="form-left-input"
                                 v-decorator="['checkCode', { rules: [{ required: true, message: '请输入单据单号' }] }]" />
                    </a-form-item>
                    <a-form-item label="单据日期">
                        <a-date-picker  v-decorator="['checkDate', { rules: [{ required: true, message: '请输入单据日期' }] }]"  @change="changeDate"  />
                    </a-form-item>
                    <a-form-item label="盘前库存">
                        <span>{{resultObj.storageName}}</span>
                    </a-form-item>
                    <a-form-item label="盘点截止时间">
                        <a-date-picker  v-decorator="['deadline', { rules: [{ required: true, message: '请选择盘点截止时间' }] }]"
                                        :disabled-date="disabledEndDate"
                                        @change="changeDate1"  />
                    </a-form-item>
                    <a-form-item label="经办人">
                        <a-select  v-decorator="['transactorId',{ rules: [{ required: false}] },]"
                                   placeholder="请选择经办人"
                        >
                            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                            <a-select-option v-for="item in agentList" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </div>
                <div class="form-left">
                    <a-form-item label="盘前库存">
                        <span>{{model.stockCount}}</span>
                    </a-form-item>
                    <a-form-item label="盘点库存">
                        <a-input-number  placeholder="请输入盘点库存"   @change="e => changeNumber(e)" v-decorator="['checkStock', { rules: [{ required: true, message: '请输入盘点库存' }] }]"></a-input-number>
                    </a-form-item>
                    <a-form-item label="盘点结果">
                        <span>{{resultObj.result}}</span>
                    </a-form-item>
                    <a-form-item label="盘点状态">
                        <span style="color: #FF0000" v-if="!resultObj.checkFlg">未盘点</span>
                        <span v-else>盘点</span>
                    </a-form-item>
                </div>
            </a-form>
        </a-modal>
        <a-modal v-model="isShowModel2" class="material-model"   @cancel="onCancel" :closable="false" :footer="null">
            <div class="material-content1"> <img src="@/assets/image/tishi.png"/>请先选择仓库</div>
        </a-modal>
    </div>
</template>
<script>
    import {getCreateVoucherCode,savestockfinsh} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    import moment from 'moment';
    import pick from 'lodash.pick'
    export default {
        mixins:[mixins],
        data(){
            return{
                isShowModel:false,
                okText:'好',
                isShowModel1:false,
                title:'单品盘点',
                form: this.$form.createForm(this),
                okText1:'完成盘点',
                cancelText:'取消退出',
                isShowModel2:false,
                title1:'提示',
                model:{},
                resultObj:{
                    result:0,
                    checkFlg:false,
                    checkStorageId:'',
                    storageName:'',
                },
                dataTime:'',
                dataTime1:'',
            }
        },
        watch: {

        },
        mounted () {
            this.agentListSelect()
        },
        created () {

        },
        components: {


        },
        methods: {
            moment,
            onOpen(index,record,name,id){
                if(index == 1){
                    this.isShowModel = true
                }else if(index == 2){
                    this.resultObj.storageName = name
                    this.resultObj.checkStorageId = id
                    this.model = {}
                    this.form = this.$form.createForm(this)
                    this.model = Object.assign({},record)
                    let data = new FormData()
                    data.append('voucherType','25')
                    data.append('companyStoreId',this.$store.state.shopId)
                    getCreateVoucherCode(data,{}).then((res)=> {
                        if (res.success) {
                            this.model.checkCode = res.result
                            // this.model.checkStock =
                            this.isShowModel1 = true
                            this.$nextTick(()=>{
                                this.form.setFieldsValue(pick(this.model,'checkCode','checkStock'))
                                this.form.setFieldsValue({checkDate:new Date().toLocaleDateString()?moment(new Date().toLocaleDateString()):null})
                            })
                        }
                    })
                }else if(index == 3){
                    this.isShowModel2 = true
                }
            },
            disabledEndDate(endValue){
                if (!endValue) {
                    return false;
                }
                return endValue.valueOf() < moment(new Date().toLocaleDateString()).valueOf();
            },
            onCancel(){
                this.isShowModel = false
                this.isShowModel1 = false
                this.isShowModel2 = false
            },
            onCofrimForm(){
                this.isShowModel = false
                this.$router.push('/librarymanage/warehousemanage/addAdjustment')
            },
            /**
             * @description: 单据日期（方法描述）
             */
            changeDate(date, dateString){
                this.dataTime = dateString
            },
            /**
             * @description:盘点截止时间（方法描述）
             */
            changeDate1(date, dateString){
                this.dataTime1 = dateString
            },
            /**
             * @description:盘点库存（方法描述）
             */
            changeNumber(value){
                this.resultObj.result = value - this.model.stockCount
                this.resultObj.checkFlg = true
            },
            /**
             * @description:盘点库存3个按钮（方法描述）
             */
            onCofrimForm1(){
                this.form.validateFields((err, values) => {
                    if(!err){
                        savestockfinsh({
                            companyStoreId:this.$store.state.shopId,
                            companyId:this.$store.state.companyId,
                            checkCode:values.checkCode,
                            checkDate: this.isEmpty(this.dataTime) ? this.getTime() :this.dataTime,
                            checkStorageId:this.resultObj.checkStorageId,
                            deadline:this.dataTime1,
                            transactorId:values.transactorId,
                            itemList:[
                                {
                                    productId:this.model.id,
                                    productSkuId:this.model.skuId,
                                    checkStock:values.checkStock,
                                    productCategoryId:this.model.categoryId,
                                    systemStock : this.model.stockCount
                                }
                            ]
                        },{}).then((res)=>{
                            if(res.success){
                                this.isShowModel1 = false
                                this.$message.success(res.logMessage)
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }else{
                        this.$message.warn('您还有必填数据没有填写哦~')
                    }
                })
            },
        },

    }
</script>
<style lang="scss">
    .material-form{
        input{
            width: 200px;
        }
        .ant-calendar-picker{
            width: 200px;
            input{
                width: 200px;
            }
        }
        .ant-input-number{
            width: 150px;
        }
    }
    .material-model{
        width: 260px !important;
        height: 70px !important;
        .ant-modal-content{
            height: 70px;
        }
        .material-content1{
            display: flex;
            align-items: center;
            justify-content: center;
            color: #343434;
            font-size: 16px;
            img{
                width: 24px;
                margin-right: 16px;
            }
        }
    }
    .material-model1{
        width: 536px !important;
        height: 350px !important;
    }
    .material-model2{
        width: 716px !important;
        height: 550px !important;
    }
    .form-left-input{
        .ant-input-suffix{
            right: 15px !important;
        }
    }
</style>
<style scoped lang="scss">
    .model-p{
        margin-left: 55px;
        margin-right: 30px;
        color: #333333;
        line-height: 25px;
    }
    .model-p1{
        margin-top: 50px;
    }
    .material-form{
        padding-left: 20px;
        .form-left{
            flex: 1;
            margin-right: 20px;
        }
        .form-left:last-child{
            margin-right: 0px;
        }
    }
    .model-btn{
        display: flex;
        height: 100px;
        align-items: center;
        justify-content: center;
        button{
            margin-right: 16px;
        }
    }
</style>
